module.exports = __webpack_public_path__ + "static/media/expii.bf3ec8ca.jpg";